var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('header-page'),_c('welcome-page'),_c('trending-offer'),_c('br'),_c('br'),_c('top-destination'),_c('br'),_c('br'),_c('download-enjoy'),_c('br'),_c('br'),_c('footer-page'),_c('br'),_c('contact-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }